@if (contentEdit && item) {
  <div class="expand-links-edit">
    <coin-v2-text-input
      [label]="'cms.content-pages.headline-text' | translate"
      [placeholder]="'cms.content-pages.headline-text' | translate"
      [(ngModel)]="item.headline" />
    <coin-v2-text-input
      [label]="'cms.content-pages.icon' | translate"
      [placeholder]="'cms.content-pages.icon' | translate"
      [(ngModel)]="item.icon" />
    <div class="expand-links__amount">
      <coin-v2-number-input
        aria-label="icon"
        [label]="'cms.content-pages.amount-links' | translate"
        [placeholder]="'cms.content-pages.amount-links' | translate"
        [(ngModel)]="item.amountLinks" />
      <coin-v2-button
        type="primary"
        text="Apply amount links"
        (click)="applyAmountLinks()"></coin-v2-button>
    </div>
  </div>
}

@if (item) {
  <div class="expand-links-main">
    <div
      class="expand-links-box"
      (click)="boxExpanded = !boxExpanded">
      <div class="expand-links-text">
        @if (item.icon) {
          <span class="material-icons-outlined">{{ item.icon }}</span>
        }
        <p>{{ item.headline }}</p>
        <span class="material-icons-outlined">expand_more</span>
      </div>
    </div>
    <div
      class="expand-box-linkcontent"
      [ngClass]="{ 'expand-box-linkcontent--expanded': boxExpanded || contentEdit }">
      <coin-v2-text-input
        [label]="'content-pages.search' | translate"
        [placeholder]="'content-pages.search' | translate"
        [(ngModel)]="expandSearch"
        (input)="searchAllLinks($event)" />
      <ngx-simplebar class="content-container primary-scrollbar-vertical simple-table no-space">
        @for (linkItem of item.allLinks; track linkItem; let i = $index) {
          <div
            class="expand-links-item"
            animate.enter="expand"
            animate.leave="shrink">
            <img
              aria-label="download icon"
              [src]="imagePath + 'coin/images/originals/download_icon_SE.png'" />
            @if (contentEdit) {
              <coin-v2-text-input
                [label]="'cms.content-pages.link-text' | translate"
                [(ngModel)]="linkItem.text" />
            }
            @if (contentEdit) {
              <coin-v2-text-input
                [label]="'cms.content-pages.link-href' | translate"
                [placeholder]="'cms.content-pages.link-href-placeholder' | translate"
                [(ngModel)]="linkItem.link" />
            }
            @if (contentEdit) {
              <coin-icon-button
                type="secondary"
                classs="button-spacing"
                icon="clear"
                (click)="deleteItem(i)"></coin-icon-button>
            }
            @if (!contentEdit) {
              <a
                class="flex-one text-black"
                target="_blank"
                (click)="openLink(linkItem.link)">
                {{ linkItem.text }}
              </a>
            }
          </div>
        }
      </ngx-simplebar>
    </div>
  </div>
}
